import { Button, Col, Drawer, message, Row, Skeleton, Tree } from 'antd'
import useWorkshopStore from '@/store/workshop.ts'
import { useShallow } from 'zustand/react/shallow'
import { useEffect, useRef } from 'react'
import useGlobalStore from '@/store'
import { useSetState } from 'ahooks'
import { dfs, findAllPath } from 'shj-utils'
import { CaretDownFilled, StarFilled } from '@ant-design/icons'
import styles from './index.module.less'
import classNames from 'classnames'
import { useNavigate } from 'react-router-dom'
import { navigatePage } from '@/common/utils.ts'

const FavorMenu = props => {
  const { loading } = props
  const [state, setState]: any = useSetState({
    list: [],
  })

  const navigate = useNavigate()

  const { menuCollect, appCollectLoading } = useWorkshopStore(
    useShallow((state: any) => ({
      menuCollect: state.menuCollect,
      appCollectLoading: state.appCollectLoading,
    }))
  )

  const { menu, menuLoading } = useGlobalStore(
    useShallow((state: any) => ({
      menu: state.menu,
      menuLoading: state.menuLoading,
    }))
  )

  useEffect(() => {
    if (menuCollect && menu.length) {
      const list: any[] = []
      menuCollect.map(key => {
        dfs(menu, item => {
          if (key === item.nid) {
            list.push(item)
          }
        })
      })
      setState({ list })
    }
  }, [menuCollect, menu])

  const handleRoute = d => {
    navigatePage(d.apppath, d.path, navigate)
  }

  return (
    <Row style={{ paddingTop: 4, paddingBottom: 10, minHeight: 46 }} wrap={false}>
      {state.list.map(d => {
        return (
          <Col
            style={{
              flexBasis: '20%',
              width: '20%',
              flexShrink: 0,
            }}
            className={styles.favorMenuItem}
            key={d.nid}
          >
            <Button type="link" onClick={() => handleRoute(d)} block title={d.name}>
              {d.name}
            </Button>
          </Col>
        )
      })}
      {loading ? <Skeleton active /> : null}
    </Row>
  )
}

export const FavorMenuDrawer = props => {
  const { open, onClose } = props
  const isExpanded = useRef<any>(false)
  const [state, setState]: any = useSetState({
    appTree: [],
    expandedKeys: [],
  })

  const { appList, menuCollect, setMenuCollect, caasMenu } = useWorkshopStore(
    useShallow((state: any) => ({
      appList: state.appList,
      menuCollect: state.menuCollect,
      setMenuCollect: state.setMenuCollect,
      caasMenu: state.caasMenu,
    }))
  )

  const { menu } = useGlobalStore(
    useShallow((state: any) => ({
      menu: state.menu,
    }))
  )

  useEffect(() => {
    if (appList.length && menu.length && open) {
      const list = caasMenu ? [...appList, caasMenu] : appList
      const appTree = list
        .map(app => {
          const item = menu.find(d => d.key === app.code)
          if (item) {
            let title = app.app.name
            if (app.app.code === 'enterpriseBackground') {
              title = '企业后台'
            }
            return { ...app, title, value: app.id, children: item.children }
          }
          return app
        })
        .filter(d => d.children)

      dfs(appTree, d => {
        if (!d.title) {
          d.title = d.name
        }
        if (!d.value) {
          d.value = d.nid
        }
        d.code = d.key
        d.isLeaf = !Array.isArray(d.children)
        d.key = d.value
      })
      // console.log('appTree', appTree)
      setState({ appTree })
    }
    return () => {
      isExpanded.current = false
    }
  }, [appList, menu, open])

  useEffect(() => {
    if (state.appTree.length && menuCollect.length && !isExpanded.current) {
      const expandedKeys = Array.from(state.expandedKeys)
      for (const key of menuCollect) {
        const path = findAllPath({ key }, state.appTree)
        path.map(d => {
          if (!expandedKeys.includes(d.key) && d.key !== key) {
            expandedKeys.push(d.key)
          }
        })
      }
      setState({ expandedKeys })
      isExpanded.current = true
    }
  }, [state.appTree, menuCollect])

  const handleCollect = (e, item) => {
    if (!item.isLeaf) return
    e.stopPropagation()
    let nextMenuCollect = Array.from(menuCollect)
    if (menuCollect.includes(item.value)) {
      nextMenuCollect = nextMenuCollect.filter(id => `${id}` !== `${item.value}`)
    } else {
      nextMenuCollect.push(item.value)
      if (nextMenuCollect.length > 5) {
        nextMenuCollect = nextMenuCollect.splice(-5)
        message.warning('收藏数量已达上限，靠前的收藏将被取消')
      }
    }
    setMenuCollect(nextMenuCollect)
  }

  return (
    <Drawer title="快捷功能" open={open} onClose={onClose} width="30%">
      <Tree
        treeData={state.appTree}
        blockNode
        selectable={false}
        expandedKeys={state.expandedKeys}
        onExpand={keys => setState({ expandedKeys: keys })}
        switcherIcon={
          <div style={{ lineHeight: '34px' }}>
            <CaretDownFilled />
          </div>
        }
        titleRender={(item: any) => {
          const isCollect = item.isLeaf && menuCollect.includes(item.value)
          return (
            <Row
              justify="space-between"
              align="middle"
              style={{ padding: '6px 0' }}
              onClick={e => handleCollect(e, item)}
            >
              <Col>{item.title}</Col>
              {item.isLeaf ? (
                <Col>
                  <div
                    className={classNames(styles.favorIconBtn, { [styles.selected]: isCollect })}
                    // onClick={e => handleCollect(e, item)}
                  >
                    <StarFilled />
                  </div>
                </Col>
              ) : null}
            </Row>
          )
        }}
      />
    </Drawer>
  )
}

export default FavorMenu
